var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tipShow
    ? _c("div", { staticClass: "popup" }, [
        _c(
          "div",
          {
            staticClass: "content",
            attrs: { id: "googlePhotosV2Tips", language: this.$i18n.locale }
          },
          [
            _c("div", { staticClass: "title" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "language.popup.cloudExploerPopup.googlePhotosV2Tips"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    return _vm.closeDeal()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tips-content" }, [
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "language.popup.cloudExploerPopup.googlePhotosV2TipsDesc"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "language.popup.cloudExploerPopup.googlePhotosV2Tips1"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "language.popup.cloudExploerPopup.googlePhotosV2Tips2"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "language.popup.cloudExploerPopup.googlePhotosV2Tips3"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "language.popup.cloudExploerPopup.googlePhotosV2Tips4"
                      )
                    )
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tips-footer" }, [
              _c(
                "div",
                {
                  on: {
                    click: function($event) {
                      _vm.isChecked = !_vm.isChecked
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "icon-util",
                    class: _vm.isChecked ? "check-small" : "nocheck-small"
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.popup.cloudExploerPopup.googlePhotosV2TipsShow"
                        )
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "whilt",
                  on: {
                    click: function($event) {
                      return _vm.closeDeal()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      return _vm.okDeal()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85d451d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85d451d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_exploer_popups/google_photos_v2_tips_popup.vue
// module id = null
// module chunks = 